export { default as Header } from './Header';



// WEBPACK FOOTER //
// ./src/components/Header/index.js